import { Amplify } from 'aws-amplify';
import { getStage, getUserConfig } from 'src/util/config';

const isLocalHost = window.location.hostname === "localhost"

const getPersonalConfig = () => {
    const userConfig = getUserConfig();
    const redirectUrl = `https://${userConfig.subdomain}.dev-royalties.paper.music.amazon.dev`;

    return {
        identityPoolId: userConfig.identityPoolId,
        region: 'us-east-1',
        userPoolId: userConfig.userPoolId,
        userPoolWebClientId: userConfig.clientId,
        mandatorySignIn: true,
        oauth: {
            domain: userConfig.domain,
            redirectSignIn: isLocalHost ? 'http://localhost:4321' : redirectUrl,
            redirectSignOut: isLocalHost ? 'http://localhost:4321' : redirectUrl,
            scope: ['openid'],
            responseType: 'code'
        }
    };
};

// user pool: contract-manager-userpool-beta under MusicPaperContractConfigurationBeta AWS account
const testConfig = {
    identityPoolId: 'us-east-1:5c9e9108-c249-43f3-b72b-0ba0a95a5903',
    region: 'us-east-1',
    userPoolId: 'us-east-1_wpgdZQ5pj',
    userPoolWebClientId: '3ns4int009iu0pv5g01bmgidpt',
    mandatorySignIn: true,
    oauth: {
        domain: 'contract-manager-beta.auth.us-east-1.amazoncognito.com',
        redirectSignIn: 'http://localhost:4321',
        redirectSignOut: 'http://localhost:4321',
        scope: ['openid'],
        responseType: 'code'
    }
};

// user pool: contract-manager-userpool-beta under MusicPaperContractConfigurationBeta AWS account
const betaConfig = {
    identityPoolId: 'us-east-1:5c9e9108-c249-43f3-b72b-0ba0a95a5903',
    region: 'us-east-1',
    userPoolId: 'us-east-1_wpgdZQ5pj',
    userPoolWebClientId: '3ns4int009iu0pv5g01bmgidpt',
    mandatorySignIn: true,
    oauth: {
        domain: 'contract-manager-beta.auth.us-east-1.amazoncognito.com',
        redirectSignIn: 'https://beta.royalties.paper.music.amazon.dev',
        redirectSignOut: 'https://beta.royalties.paper.music.amazon.dev',
        scope: ['openid'],
        responseType: 'code'
    }
};

// user pool: contract-manager-userpool-gamma under MusicPaperContractConfigurationGamma AWS account
const gammaConfig = {
    identityPoolId: 'us-east-1:48c6fe1e-fd18-4566-8989-9659dcac740b',
    region: 'us-east-1',
    userPoolId: 'us-east-1_D688jTC26',
    userPoolWebClientId: '38rvgu7a4akq271na8m8dfjffv',
    mandatorySignIn: true,
    oauth: {
        domain: 'contract-manager-gamma.auth.us-east-1.amazoncognito.com',
        redirectSignIn: 'https://gamma.royalties.paper.music.amazon.dev',
        redirectSignOut: 'https://gamma.royalties.paper.music.amazon.dev',
        scope: ['openid'],
        responseType: 'code'
    }
};

// user pool: contract-manager-userpool-prod under MusicPaperContractConfigurationProd AWS account
const prodConfig = {
    identityPoolId: 'us-east-1:b4ad2053-0df6-4d5b-bcdf-8d0365132425',
    region: 'us-east-1',
    userPoolId: 'us-east-1_KsVdvb09v',
    userPoolWebClientId: '6929htc39emirm5p23b9r2saq6',
    mandatorySignIn: true,
    oauth: {
        domain: 'contract-manager-prod.auth.us-east-1.amazoncognito.com',
        redirectSignIn: 'https://prod.royalties.paper.music.amazon.dev',
        redirectSignOut: 'https://prod.royalties.paper.music.amazon.dev',
        scope: ['openid'],
        responseType: 'code'
    }
};

switch (getStage()) {
    case 'personal':
        Amplify.configure({
            Auth: getPersonalConfig()
        });
        break;
    case 'test':
        Amplify.configure({
            Auth: testConfig
        });
        break;
    case 'beta':
        Amplify.configure({
            Auth: betaConfig
        });
        break;
    case 'gamma':
        Amplify.configure({
            Auth: gammaConfig
        });
        break;
    case 'prod':
        Amplify.configure({
            Auth: prodConfig
        });
        break;
}
